import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react'

const ActivityDetailLayout = (props) => (
  <div>
        <Placeholder name="main-layout" rendering={props.rendering} itemid={props.itemidkey} />
  </div>
);

export default ActivityDetailLayout;
